export const MESSAGE_TAG_RESPONSE_TYPE = {
    CANNED_RESPONSE: "CANNED_RESPONSE",
    CONVERSATION_RESPONSE: "CONVERSATION_RESPONSE",
};

export const ANALYZER_ACTIONS = {
    COPY_RESPONSE: "COPY_RESPONSE",
    ANALYZE_MESSAGE: "ANALYZE",
};
